import initialState from './initialState';
import {
  FETCH_AGREEMENT_DATA,
  RECEIVE_AGREEMENT_DATA,
  RESET_AGREEMENT_DATA,
  RECEIVE_ERROR_IN_AGREEMENT_FETCH,
  RECEIVE_AGREEMENT_NUMBERS,
  RECEIVE_AGREEMENT_DETAILS,
  RECEIVE_WHSE_EXCEPTIONS,
  RECEIVE_OPCO_EXCEPTIONS,
  CLEAR_AGREEMENT_DETAILS,
  RECEIVE_UPDATE_AGREEMENT_RESPONSE,
  RECEIVE_CREATE_AGREEMENT_RESPONSE,
  RECEIVE_RECALCULATE_AGREEMENT_RESPONSE,
  RECEIVE_RECALC_DECLINE_RESPONSE,
  RECEIVE_DELETE_AGREEMENT_RESPONSE,
  RECEIVE_COMMENT_WITH_ATTACHMENT,
  RESET_AGREEMENT_DETAILS,
  RESET_AGREEMENT_NUMBERS,
  RESET_ERROR_MESSAGE,
  RECEIVE_ITEM_GROUPS,
  RECEIVE_ITEM_GROUP,
  RECEIVE_VENDOR_ITEMS,
  RECEIVE_ITEM_GROUP_DELETE_RESPONSE,
  RECEIVE_CLONE_AGREEMENT_RESPONSE,
  RECEIVE_EXCEPTIONS_SAVE_RESPONSE,
  RECEIVE_EXCEPTIONS_DELETE_RESPONSE,
  RECEIVE_EXCEPTION_CODES,
} from '../actions/agreementActions';
import { RECEIVE_ERROR_IN_AGREEMENT_NUMBERS } from '../actions/errorDialogActions';
import { HOUSE_INDICATOR } from '../../helpers/constants';

/**
 * Agreement Data Reducer Class
 * @author skit1169
 */

function handleAgreements(state, { type, data }) {
  if (type === RECEIVE_AGREEMENT_DETAILS) {
    const { agreementHeader, ...rest } = { ...data };
    return {
      ...state, agreementDetails: { ...agreementHeader, ...rest }, deleted: false, declineRecalculation: false, loading: false
    };
  }

  if (type === RESET_AGREEMENT_DETAILS) {
    return {
      ...state, agreementDetails: {}, loading: false
    };
  }

  if (type === RECEIVE_UPDATE_AGREEMENT_RESPONSE) {
    return { ...state, recalcStatus: { ...data }, loading: false };
  }

  if (type === RECEIVE_CREATE_AGREEMENT_RESPONSE) {
    return { ...state, createStatus: { ...data }, loading: false };
  }

  if (type === RECEIVE_CLONE_AGREEMENT_RESPONSE) {
    return { ...state, cloneStatus: { ...data }, loading: false };
  }

  if (type === RECEIVE_RECALCULATE_AGREEMENT_RESPONSE) {
    return { ...state, recalculateResponse: { ...data }, loading: false };
  }

  if (type === RECEIVE_RECALC_DECLINE_RESPONSE) {
    return { ...state, declineRecalculation: true, loading: false };
  }

  if (type === RECEIVE_DELETE_AGREEMENT_RESPONSE) {
    return { ...state, deleted: true, loading: false };
  }

  if (type === CLEAR_AGREEMENT_DETAILS) {
    const { opcos } = state;
    return { opcos, loading: false };
  }

  if (type === RESET_AGREEMENT_DATA) {
    return initialState.agreementData;
  }

  return null;
}

function handleItemGroups(state, { type, data }) {
  if (type === RECEIVE_ITEM_GROUPS) {
    return { ...state, itemGroups: data, loading: false };
  }

  if (type === RECEIVE_ITEM_GROUP_DELETE_RESPONSE) {
    return {
      ...state,
      itemGroups: state.itemGroups.filter((group) => group !== data.itemGroup),
      loading: false,
    };
  }

  if (type === RECEIVE_VENDOR_ITEMS) {
    return { ...state, vendorItems: data, loading: false };
  }

  if (type === RECEIVE_ITEM_GROUP) {
    return { ...state, itemGroup: data, loading: false };
  }

  return null;
}

function handleExceptions(state, { type, data }) {
  if (type === RECEIVE_WHSE_EXCEPTIONS) {
    return { ...state, whseExceptions: data.exceptions, loading: false };
  }

  if (type === RECEIVE_OPCO_EXCEPTIONS) {
    return { ...state, opcoExceptions: data.exceptions, loading: false };
  }

  if (type === RECEIVE_EXCEPTIONS_SAVE_RESPONSE) {
    return { ...state, recalcStatus: { recalculate: true }, loading: false };
  }

  if (type === RECEIVE_EXCEPTIONS_DELETE_RESPONSE) {
    if (data.houseIndicator === HOUSE_INDICATOR.OPCO) {
      return {
        ...state, recalcStatus: { recalculate: true }, opcoExceptions: {}, loading: false
      };
    }
    return {
      ...state, recalcStatus: { recalculate: true }, whseExceptions: {}, loading: false
    };
  }

  if (type === RECEIVE_EXCEPTION_CODES) {
    return { ...state, exceptionCodes: data, loading: false };
  }

  return null;
}

export default function agreementDataReducer(state, { type, data }) {
  if (typeof state === 'undefined') {
    return initialState.agreementData;
  }

  if (type === FETCH_AGREEMENT_DATA) {
    return { ...state, loading: true, error: { show: false, message: '' } };
  }

  if (type === RESET_ERROR_MESSAGE) {
    return { ...state, error: { show: false, message: '' } };
  }

  if (type === RECEIVE_AGREEMENT_DATA) {
    return { ...state, ...data, loading: false };
  }

  if (type === RECEIVE_AGREEMENT_NUMBERS) {
    return { ...state, agreementNumbers: { ...data }, loading: false };
  }

  if (type === RESET_AGREEMENT_NUMBERS) {
    return { ...state, agreementNumbers: {}, loading: false };
  }

  if (type === RECEIVE_ERROR_IN_AGREEMENT_NUMBERS) {
    return { ...state, agreementNumbers: {}, loading: false };
  }

  if (type === RECEIVE_ERROR_IN_AGREEMENT_FETCH) {
    return { ...state, loading: false, error: { show: true, message: data } };
  }

  const agreementDetailsState = handleAgreements(state, { type, data });
  if (agreementDetailsState) {
    return agreementDetailsState;
  }

  const itemGroupsState = handleItemGroups(state, { type, data });
  if (itemGroupsState) {
    return itemGroupsState;
  }

  const exceptionsState = handleExceptions(state, { type, data });
  if (exceptionsState) {
    return exceptionsState;
  }

  if (type === RECEIVE_COMMENT_WITH_ATTACHMENT) {
    return {
      ...state,
      agreementDetails: {
        ...state.agreementDetails,
        newComment: { ...data },
      },
      loading: false,
    };
  }

  return state;
}
